import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import { CSR_TIMER_CACHE_KEY, timeLabelData } from './const'

const getTranslatedText = (key, val, t) => {
  const isValMoreThanOne = val > 1
  const labelData = timeLabelData[key]
  const locizeKey = isValMoreThanOne
    ? labelData.key
    : labelData.key.slice(0, -1)
  const defaultText = isValMoreThanOne
    ? labelData.value
    : labelData.value.slice(0, -1)

  return hasLocizeTranslation(t, locizeKey, defaultText)
}

const getTimesLabel = (key, val, t) => {
  switch (key) {
    case 'second':
    case 'minute':
    case 'hour':
    case 'day':
      return getTranslatedText(key, val, t)
    default:
      return ''
  }
}

const getInitialTime = (initialTime) => {
  if (initialTime) {
    return {
      day: initialTime.day,
      hour: initialTime.hour,
      minute: initialTime.minute,
      second: initialTime.second,
    }
  }

  const cacheData = sessionStorage.getItem(CSR_TIMER_CACHE_KEY)
  if (typeof window !== 'undefined' && cacheData) {
    sessionStorage.removeItem(CSR_TIMER_CACHE_KEY)
    return JSON.parse(cacheData)
  }

  return {
    day: 0,
    hour: 0,
    minute: 0,
    second: 0,
  }
}

dayjs.extend(utc)

const Timer = ({ initialTime, serverTime, t }) => {
  const [timeData, setTimeData] = useState(getInitialTime(initialTime))

  useEffect(() => {
    const TIME_WORK_FROM_HOME_STARTED = 'Wed, 18 Mar 2020 02:00:00 GMT'
    let latestTime = serverTime ? dayjs(serverTime) : dayjs.utc()
    let diffTime = dayjs.utc(latestTime.diff(TIME_WORK_FROM_HOME_STARTED))
    let newTime = {}

    const timerInterval = setInterval(() => {
      diffTime = diffTime.add(1, 's')
      latestTime = latestTime.add(1, 's')
      const diffTimeFormatted = diffTime.format('HH mm ss')
      const day = latestTime.diff(dayjs(TIME_WORK_FROM_HOME_STARTED), 'day')

      const [hour, minute, second] = diffTimeFormatted.split(' ')
      newTime = {
        day,
        hour,
        minute,
        second,
      }

      setTimeData(newTime)
    }, 1000)

    return () => {
      sessionStorage.setItem(CSR_TIMER_CACHE_KEY, JSON.stringify(newTime))
      clearInterval(timerInterval)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="section-team__timer__wrapper">
      {timeData &&
        Object.keys(timeData).map((key) => (
          <React.Fragment key={key}>
            <div className="section-team__timer__item">
              <div className={Typo.h4}>{timeData[key]}</div>
              <div className={Typo.caption}>
                {getTimesLabel(key, timeData[key], t)}
              </div>
            </div>
            <div className="section-team__timer__item colon">
              <span className={Typo.h4}>:</span>
            </div>
          </React.Fragment>
        ))}
    </div>
  )
}

Timer.propTypes = {
  initialTime: PropTypes.shape({
    day: PropTypes.string,
    hour: PropTypes.string,
    minute: PropTypes.string,
    second: PropTypes.string,
  }),
  serverTime: PropTypes.string,
  t: PropTypes.func.isRequired,
}

Timer.defaultProps = {
  initialTime: null,
  serverTime: '',
}

export default withI18next()(Timer)
